import React, { useState } from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import Footer from '../../component/layout/Footer';
import emailjs from "@emailjs/browser";

const ContactUs = () => {

    const [name, setName] = useState("");
    const [mail, setmail] = useState("");
    const [massages, setMassages] = useState("");
    const [number, setNumber] = useState("");
    const [state, setState] = useState("");
    const [subject, setSubject] = useState("");
    const [city, setCity] = useState("");

    const nameChange = (e) => {
        const value = e.target.value;
        setName(value);
    };
    const stateChange = (e) => {
        const value = e.target.value;
        setState(value);
    };
    const cityChange = (e) => {
        const value = e.target.value;
        setCity(value);
    };
    const subjectChange = (e) => {
        const value = e.target.value;
        setSubject(value);
    };
    const numberChange = (e) => {
        const value = e.target.value;
        setNumber(value);
    };

    const mailChange = (e) => {
        const value = e.target.value;
        setmail(value);
    };
    const massagesChange = (e) => {
        const value = e.target.value;
        setMassages(value);
    };


    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
            .sendForm(
                "service_85vncqh",
                "template_sh7wgvk",
                "#myForm",
                "dphUMCkFYP0BZruxu"
            )
            .then(
                function (response) {
                    console.log("SUCCESS!", response.status, response.text);
                    if (response.text === "OK") {
                        setName("");
                        setmail("");
                        setMassages("");
                        setNumber("");
                        setState("");
                        setSubject("");
                        setCity("");

                    }
                },
                function (error) {
                    console.log("FAILED...", error);
                }
            );
    };

    return (
        <>

            <div className="site-breadcrumb" style={{ background: 'url(assets/yog/0101.webp)' }}>
                <div className="container">
                    <h2 className="breadcrumb-title">Contact Us</h2>
                    <ul className="breadcrumb-menu">
                        <li><Link to="/">Home</Link></li>
                        <li className="active">Contact Us</li>
                    </ul>
                </div>
            </div>

            <div className="contact-area py-120" style={{marginTop:"-80px"}}>
                <div className="container">
                    <div className="contact-content">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="contact-info">
                                    <div className="icon">
                                        <i className="fal fa-map-location-dot" />
                                    </div>
                                    <div className="content">
                                        <h5>Office Address</h5>
                                        <p>
                                            <a href="https://maps.google.com/?q=Ward+No.+15,+Hanuman+Nagar+Nai+Basti,+Raghuraj+Nagar+Satna,+M.P.+485001" target="_blank" rel="noopener noreferrer">
                                                Ward No. 15, Hanuman Nagar Nai Basti, Raghuraj Nagar Satna, (M.P.) 485001
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="contact-info">
                                    <div className="icon">
                                        <i className="fal fa-phone-volume" />
                                    </div>
                                    <div className="content">
                                        <h5>Call Us</h5>
                                        <p>
                                            <a href="tel:+917024671002"> +91 7024671002</a>
                                            <br />
                                            <a href="tel:+917240954834"> +91 7240954834</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="contact-info">
                                    <div className="icon">
                                        <i className="fal fa-envelopes" />
                                    </div>
                                    <div className="content">
                                        <h5>Email Us</h5>
                                        <a href='mailto:yogeshsolarenergy2026@gmail.com'> yogeshsolarenergy2026@gmail.com </a>
                                        <br />
                                        <br />
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-md-3">
                                <div className="contact-info">
                                    <div className="icon">
                                        <i className="fal fa-alarm-clock" />
                                    </div>
                                    <div className="content">
                                        <h5>Open Time</h5>
                                        <p>Mon - Sat (10.00AM - 05.30PM)</p>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <div className="contact-form-wrap" style={{marginTop:"-60px"}}>
                        <div className="row g-4">
                            <div className="col-lg-5">
                                <div className="contact-img">
                                    <img src="assets/yog/telecaller.webp" alt />
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="contact-form">
                                    <div className="contact-form-header">
                                        <h2>Get In Touch With Us</h2>
                                    </div>
                                    <div className="form-message" />
                                    <form method="post" onSubmit={sendEmail} id="myForm">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <div className="form-icon">
                                                        <i className="far fa-user-tie" />
                                                        <input type="text" className="form-control" placeholder="Your Name"
                                                            name="from_name"
                                                            onChange={(e) => nameChange(e)}
                                                            required
                                                            value={name}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <div className="form-icon">
                                                        <i className="far fa-envelope" />
                                                        <input type="email" className="form-control" placeholder="Your Email"
                                                            id="email"
                                                            name='email'
                                                            onChange={(e) => mailChange(e)}
                                                            value={mail}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-icon">
                                                <i className="far fa-pen" />
                                                <input type="number" className="form-control" placeholder="Your Subject"
                                                    id="phone"
                                                    name='phone'
                                                    onChange={(e) => numberChange(e)}
                                                    value={number}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-icon">
                                                <i className="far fa-comment-lines" />
                                                <textarea cols={30} rows={5} className="form-control" placeholder="Write Your Message"
                                                    onChange={(e) => massagesChange(e)}
                                                    name='massage'
                                                    value={massages}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <button type="submit" className="theme-btn">Send
                                            Message <i className="far fa-paper-plane" /></button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="contact-map" style={{ marginTop: "-80px", borderRadius: "50px" }}>
                <div className="mapouter"><div className="gmap_canvas"><iframe className="gmap_iframe" width="100%" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=1600&height=400&hl=en&q=Yogesh Solar Energy Ward No. 15, Hanuman Nagar Nai Basti, Raghuraj Nagar Satna, (M.P.) 485001&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://embed-googlemap.com">embed-googlemap.com</a></div><style dangerouslySetInnerHTML={{ __html: ".mapouter{position:relative;text-align:right;width:100%;height:400px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:400px;}.gmap_iframe {height:400px!important;}" }} /></div>

            </div>







        </>
    )
}

export default ContactUs